import * as PIXI from 'pixi.js';

export default class ObservablePoint extends PIXI.ObservablePoint {}
